export const LOADING_ITEM = "LOADING_ITEM";

export const POST_BUDGET = "POST_BUDGET";
export const DELETE_BUDGET = "DELETE_BUDGET";
export const UPDATE_BUDGET = "UPDATE_BUDGET";
export const GET_BUDGET_LIST = "GET_BUDGET_LIST";
export const GET_BUDGET_BY_ID = "GET_BUDGET_BY_ID";